import {Col, Divider, InputNumber, Row, Slider, Statistic, Tag, Typography} from "antd";
import CountUp from "react-countup";
import React, {useEffect, useState} from "react";
import {CloseCircleOutlined} from "@ant-design/icons";

const {Text} = Typography;

export function DashboardBuildingEmission({
                                              isOpenBuildingEmissions,
                                              setIsOpenBuildingEmissions,
                                              setEmMainBuilding,
                                              data,
                                              setFloorspaceTotal,
                                              setErrorBuildingEmissions
                                          }) {

    const [emTot, setEmTot] = useState(0)
    const [emTotPer, setEmTotPer] = useState(0)
    const [totResidential, setTotResidential] = useState(0)
    const [totResidentialPer, setTotResidentialPer] = useState(0)
    const [totNonResidential, setTotNonResidential] = useState(0)
    const [totNonResidentialPer, setTotNonResidentialPer] = useState(0)
    const [residential, setResidential] = useState(0)
    const [residentialSlider, setResidentialSlider] = useState(0)
    const [nonResidential, setNonResidential] = useState(0)
    const [nonResidentialSlider, setNonResidentialSlider] = useState(0)
    const [totalFloorSpace, setTotalFloorSpace] = useState(0)
    const [gasseous, setGasseous] = useState(0)
    const [liquid, setLiquid] = useState(0)
    const [electricity, setElectricity] = useState(0)
    const [statusForm, setStatusForm] = useState('')
    const [sumForm, setSumForm] = useState(0)

    const marks = {
        0: '0%',
        100: '100%',
    };
    const formatter = (value) => <CountUp end={value} separator=" " decimals={3}/>;

    function close() {
        setIsOpenBuildingEmissions(false)
    }

    useEffect(() => {

        setResidential(data.area_residential)
        setNonResidential(data.area_nonresidential)

        setFloorspaceTotal(data.area_residential + data.area_nonresidential)
        setTotalFloorSpace(data.area_residential + data.area_nonresidential)
        
        setGasseous(data.ratio_fuel_gaseous)
        setLiquid(data.ratio_fuel_lquid)
        setElectricity(data.ratio_fuel_electricity)
        
        setResidentialSlider(data.slider_residential)
        setNonResidentialSlider(data.slider_nonresidential)

    }, [data])

    useEffect(() => {

        setResidential(data.area_residential_def * (1 + (residentialSlider / 100)))

    }, [residentialSlider])

    useEffect(() => {

        setNonResidential(data.area_nonresidential_def * (1 + (nonResidentialSlider / 100)))

    }, [nonResidentialSlider])

    useEffect(() => {
        const value = (residential + nonResidential) / data.area_total * 100
        
        setFloorspaceTotal(value)
        setTotalFloorSpace(residential + nonResidential)

    }, [residential, nonResidential, data]);

    useEffect(() => {
        const value = residential * data.eff_residential * (
            (gasseous * data.em_fact_fuel_gaseous)
            + (liquid * data.em_fact_fuel_lquid)
            + (electricity * data.em_fact_fuel_electricity)) / (1000000*100)

        setTotResidential(value)

        setTotResidentialPer(Math.round((value / data.residential_emissions) * 100) - 100)

    }, [residential, gasseous, liquid, electricity]);

    useEffect(() => {
        const value = nonResidential * data.eff_nonresidential * (
            (gasseous * data.em_fact_fuel_gaseous)
            + (liquid * data.em_fact_fuel_lquid)
            + (electricity * data.em_fact_fuel_electricity)) / (1000000*100)

        setTotNonResidential(value)

        setTotNonResidentialPer(Math.round((value / data.non_residential_emissions) * 100) - 100)

    }, [nonResidential, gasseous, liquid, electricity]);

    useEffect(() => {
        const value = totResidential + totNonResidential
        const per = ((value / data.building_emissions) * 100) - 100

        setEmMainBuilding(value)
        setEmTot(value)
        setEmTotPer(Math.round(per))
    }, [totResidential, totNonResidential]);

    useEffect(() => {
        const sum = Math.floor(gasseous + liquid + electricity)
        setSumForm(sum)
        if (sum === 100) {
            setStatusForm('')
            setErrorBuildingEmissions(false)
        } else {
            setStatusForm('error')
            setErrorBuildingEmissions(true)
        }
    }, [gasseous, liquid, electricity]);

    return (
        <div className="panelDashboardContainer"
             style={{
                 display: isOpenBuildingEmissions ? 'block' : 'none',
             }}
        >
            <div className="panelDashboardTitleIcon"><CloseCircleOutlined onClick={() => close()}/></div>
            <div className="panelDashboardTitle">Estimated CO2 Building Emissions</div>

            <div style={{
                padding: '20px 10px 0 10px',
                display: 'flex',
                justifyContent: 'space-evenly',
            }}>
                <div className="panelDashboardSumBuilding">
                    {totResidentialPer == 0 && <div style={{height: 22, width: 60}}></div>}
                    {totResidentialPer < 0 && <Tag color="success" style={{width: 50}}>{totResidentialPer} %</Tag>}
                    {totResidentialPer > 0 && <Tag color="error" style={{width: 50}}>{totResidentialPer} %</Tag>}
                    <Statistic
                        title={<span>Residential<br/><small>MtCO2e/year</small></span>}
                        value={totResidential} formatter={formatter}/>
                </div>

                <div className="panelDashboardSumBuilding">
                    {totNonResidentialPer == 0 && <div style={{height: 22, width: 60}}></div>}
                    {totNonResidentialPer < 0 &&
                        <Tag color="success" style={{width: 50}}>{totNonResidentialPer} %</Tag>}
                    {totNonResidentialPer > 0 &&
                        <Tag color="error" style={{width: 50}}>{totNonResidentialPer} %</Tag>}
                    <Statistic
                        title={<span>Non Residential<br/><small>MtCO2e/year</small></span>}
                        value={totNonResidential} formatter={formatter}/>
                </div>

                <div className="panelDashboardSumBuilding">
                    {emTotPer == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emTotPer < 0 && <Tag color="success" style={{width: 50}}>{emTotPer} %</Tag>}
                    {emTotPer > 0 &&
                        <Tag color="error" style={{width: 50}}>{emTotPer} %</Tag>}
                    <Statistic
                        title={<span>Total<br/><small>MtCO2e/year</small></span>}
                        value={emTot} formatter={formatter}/>
                </div>

            </div>

            <div style={{padding: '0px 20px'}}>
                <Divider orientation="left">Floorspace</Divider>
                <Text type={"secondary"}>Please note that urban growth affects vegetation sequestration figures!</Text>

                <Row style={{
                    alignItems: 'center'
                }}>
                    <Col span={6}>Residential growth</Col>
                    <Col span={1}></Col>
                    <Col span={12}><Slider
                        marks={marks} tooltip={{open: false}}
                        value={residentialSlider}
                        onChange={(value) => setResidentialSlider(value)}/></Col>
                    <Col span={1}></Col>
                    <Col span={4} style={{textAlign: 'right', fontSize: '1.1em', fontFamily: 'monospace'}}>
                        <CountUp end={residential} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                    </Col>
                </Row>
                <Row style={{
                    alignItems: 'center'
                }}>
                    <Col span={6}>Non-residential growth</Col>
                    <Col span={1}></Col>
                    <Col span={12}><Slider
                        marks={marks} tooltip={{open: false}}
                        value={nonResidentialSlider}
                        onChange={(value) => setNonResidentialSlider(value)}/></Col>
                    <Col span={1}></Col>
                    <Col span={4} style={{textAlign: 'right', fontSize: '1.1em', fontFamily: 'monospace'}}>
                        <CountUp end={nonResidential} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                    </Col>
                </Row>
                <Row style={{
                    height: 53,
                    alignItems: 'center'
                }}>
                    <Col span={6}><b>Total floorspace</b></Col>
                    <Col span={13}></Col>
                    <Col span={1}></Col>
                    <Col span={4} style={{textAlign: 'right', fontSize: '1.1em', fontFamily: 'monospace'}}>
                        <CountUp end={totalFloorSpace} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                    </Col>
                </Row>

                <Divider orientation="left">Electricity and fuel usage</Divider>
                <Text type="secondary">the sum must be equal 100%</Text>
                <div style={{marginTop: 5}}></div>
                <Row>
                    <Col span={8}>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore80">Gaseous</span>}
                            addonAfter="%"
                            value={gasseous}
                            onChange={(value) => setGasseous(value)}/>
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore80">Liquid</span>}
                            addonAfter="%"
                            value={liquid}
                            onChange={(value) => setLiquid(value)}/>
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore80">Electricity</span>}
                            addonAfter="%"
                            value={electricity}
                            onChange={(value) => setElectricity(value)}/>
                        {statusForm === '' && <div style={{
                            marginTop: 10,
                            marginLeft: 45
                        }}><Tag color="success">correct</Tag> {sumForm} %</div>}
                        {statusForm !== '' && <div style={{
                            marginTop: 10,
                            marginLeft: 58,
                            color: '#ff4d4f'
                        }}><Tag color="error">error</Tag> {sumForm} % </div>}
                    </Col>
                    <Col span={4}></Col>
                    <Col span={12}></Col>
                </Row>

                <div style={{height: 15}}></div>
            </div>

        </div>
    )
}